module.exports = __webpack_public_path__ + "img/business.73e1779a.png";